module.exports = __webpack_public_path__ + "static/img/home_banner_2.4b5592b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_banner_2.jpg
// module id = v6rw
// module chunks = 1